import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AssignUserGroupsModal } from 'components/Modals';
import Can from 'components/Can';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Draggable from 'react-draggable';
import Paper from '@material-ui/core/Paper';
import i18n from 'i18n-js';
import Button from '@material-ui/core/Button';

import {
  Box,
  List,
  Divider,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';

import { useStyles, listTextStyles, listItemsStyles } from './UserGroups.styled';

import { usersActions } from 'state/modules/users';
import { withRouter } from 'react-router-dom';
import Paginator from 'components/Paginator';
import { Card } from 'components/UI';
import DeleteIcon from '@material-ui/icons/Delete';

const UserGroups = ({ id, selectCustomParams }) => {
  const classes = useStyles();
  const listClasses = listTextStyles();
  const listItemsClasses = listItemsStyles();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState();
  const {
    userGroups,
    paginationUserGroups,
    fetchedDeleteUserGroupSuccess,
    fetchingDeleteUserGroup,
  } = useSelector((state) => state.users);
  const [params, setParams] = useState({
    page: 1,
    limit: 3,
  });

  useEffect(() => {
    if (id) {
      dispatch(usersActions.fetchUserGroups(id, params));
    }
  }, []) // eslint-disable-line

  useEffect(() => {
    if (fetchedDeleteUserGroupSuccess) {
      dispatch(usersActions.fetchUserGroups(id, params));
    }
  }, [id, fetchedDeleteUserGroupSuccess]) // eslint-disable-line

  /**
   * Open assign user groups modal
   */
  const handleAssignUserGroup = () => {
    setOpen((prevState) => !prevState);
  };

  const handleClose = (remove) => {
    if (remove) onDeleteClick(dialogData);
    setDialogData(null);
  };

  const PaperComponent = (props) => {
    return (
      <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
  };

  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: 'Add user group',
      can: { name: 'user', action: 'update' },
      onClick: handleAssignUserGroup,
    },
  ];

  const onDeleteClick = (item) => {
    const groupId = item.id;
    dispatch(usersActions.fetchDeleteUserGroups(id, groupId));
  };

  /**
   * Handle page change
   * @param {object} event
   * @param {number} newPage New page selected
   */
  const handleChangePage = (event, newPage) => {
    const newParams = { ...params, page: newPage + 1 };
    setParams(newParams);
    dispatch(usersActions.fetchUserGroups(id, newParams));
  };

  /**
   * Handle limit / page size change
   * @param {object} event Value of the input
   */
  const handleChangeRowsPerPage = (event) => {
    const newParams = { ...params, limit: event.target.value };
    setParams(newParams);
    dispatch(usersActions.fetchUserGroups(id, newParams));
  };

  return (
    <Card
      menuItems={items}
      title="User Group"
      headerActionType="vertical"
      data-cy="user-group-widget"
    >
      <Box className={classes.cardContentPadding}>
        <List>
          {userGroups.map((val, index) => (
            <Fragment key={index}>
              <ListItem classes={{ root: classes.listItem }}>
                <ListItemText classes={listClasses} primary={`${val.name}`} />
                <Can I="delete" a="user_group">
                  <ListItemSecondaryAction classes={listItemsClasses}>
                    <Box fontSize={13}>
                      <IconButton
                        disabled={fetchingDeleteUserGroup}
                        onClick={() => setDialogData(val)}
                      >
                        <DeleteIcon style={{ color: '#8E8E93', fontSize: 16, cursor: 'pointer' }} />
                      </IconButton>
                    </Box>
                  </ListItemSecondaryAction>
                </Can>
              </ListItem>
              <Divider className={classes.divider} />
            </Fragment>
          ))}
        </List>
        <Paginator
          component="div"
          limit={params.limit}
          rowsPerPageOptions={[3]}
          onPageChange={handleChangePage}
          pagination={paginationUserGroups}
          labelRowsPerPage="Page size"
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      {open && (
        <AssignUserGroupsModal
          id={id}
          open={open}
          handleClick={handleAssignUserGroup}
          selectCustomParams={selectCustomParams}
        />
      )}
      <Dialog
        open={dialogData ? true : false}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {i18n.t('user_groups.delete_user_group')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{i18n.t('user_groups.delete_user_group_confirm')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            style={{ fontWeight: 500 }}
            onClick={() => handleClose(false)}
            color="primary"
          >
            {i18n.t('user_groups.cancel')}
          </Button>
          <Button style={{ fontWeight: 500 }} onClick={() => handleClose(true)} color="primary">
            {i18n.t('user_groups.yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default withRouter(UserGroups);
